import {useEffect, useState} from 'react'

/** Подписка на CSS-медиазапрос. */
export const useMediaQuery = (query) => {
    const get = () => typeof window !== 'undefined'
        && typeof window.matchMedia === 'function'
        && window.matchMedia(query).matches

    const [matches, setMatches] = useState(get)

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
        const mql = window.matchMedia(query)
        const onChange = () => setMatches(mql.matches)
        onChange()
        // Safari до 14 не знает addEventListener у MediaQueryList
        if (mql.addEventListener) mql.addEventListener('change', onChange)
        else mql.addListener(onChange)
        return () => {
            if (mql.removeEventListener) mql.removeEventListener('change', onChange)
            else mql.removeListener(onChange)
        }
    }, [query])

    return matches
}

// Границы совпадают с сеткой antd: xs < 576, sm < 768, md < 992
export const useIsMobile = () => useMediaQuery('(max-width: 767px)')
export const useIsNarrow = () => useMediaQuery('(max-width: 991px)')
